// [init]

export default {


	namespaced: true,

	state: {
		// Listing of all requests ( Array )
		requestsList: [],

		// Current Request being manipulated ( viewed or edited ) ( Object )
		status: '',
		activeRequest: {}
	},

	mutations: {

		// Update requestList with new list
		// @params: Array
		updateRequestList( state, newList ) {
			state.requestsList = newList;
		},

		// Add a request into requestList
		addRequest( state, newRequest ) {
			state.requestsList.push( newRequest );
		},

		// Delete a request from requestList
		// @params: identifier (String)
		deleteRequest( state, identifier ) {
			state.requestsList = state.requestsList.filter( request => {
				return request.id != identifier;
			} );
		},

		// Update the current active Request object
		// @params: newActiveRequest (Object)
		updateActiveRequest( state, newActiveRequest ) {
			state.activeRequest = newActiveRequest;
		},

		// Change status of requestForm
		// @params: newStatus (String)
		updateStatus( state, newStatus ) {
			state.status = newStatus;
		},

		resetState( state ) {
			state.activeRequest = {};
			state.status = '';
		}

	},

	actions: {
		
		/* 
		*  /GET requests API
		*  Get all requests from the server
		*  @return: Array
		*/
		getRequests( { commit, state } ) {

			return new Promise (( resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/contact-requests',
					params: {
						trash: '*',
						from: 0,
						size: 9999999
					},
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updateRequestList', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET/:id requests API
		*  Get a single request from the server
		*  @params: Array (due to vuex limitations)
		*  [0]: identifier (String)
		*  [1]: action (String: view/edit)
		*  @return: Object
		*/
		getSingleRequest( { commit, state }, params ) {

			const identifier = params[0];
			const action = params[1];

			return new Promise ( (resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/contact-requests/' + identifier,
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'resetState' );
					commit( 'updateActiveRequest', response.data );
					commit( 'updateStatus', action );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /POST requests API
		*  Add a new request to the server
		*  @params: Object (requests data)
		*  @return: Object
		*/
		addRequest( { commit, state }, data ) {

			return new Promise ( (resolve, reject ) => {

				const postData = {
					firstname: data.firstname,
					lastname: data.lastname,
					mobile: data.mobile,
					email: data.email,
					subject: data.subject,
					message: data.message
				};

				global.axios.request({
					method: 'post',
					url: '/contact-requests',
					validateStatus: ( status ) => { return status == 201; },
					data: postData
				})
				.then(response => {
					commit( 'addRequest', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});


		},

		/* 
	*  /POST/:id requests API
		*  Edits an existing request into the server
		*  @params: Object (requests data)
		*  @return: Object
		*/
		editRequest( { commit, state }, data ) {

			return new Promise ((resolve, reject ) => {

				const postData = {
					firstname: data.firstname,
					lastname: data.lastname,
					mobile: data.mobile,
					email: data.email,
					subject: data.subject,
					message: data.message
				};

				global.axios.request({
					method: 'post',
					url: '/contact-requests/' + data.id + '/update',
					validateStatus: ( status ) => { return status == 200; },
					data: postData
				})
				.then(response => {
					commit( 'addRequest', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /DELETE/:id requests API
		*  Removes an existing request into the server
		*  @params: identifier (String)
		*  @return: 200 OK
		*/
		deleteRequest( { commit, state }, identifier ) {

			return new Promise ((resolve, reject ) => {

				global.axios.request({
					method: 'post',
					url: '/contact-requests/' + identifier + '/trash',
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'deleteRequest', identifier );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /POST/:id/untrash requests API
		*  Restores a request into the server from the trash
		*  @params: identifier (String)
		*  @return: 200 OK
		*/
		untrashRequest( { commit, state }, identifier ) {

			return new Promise ( (resolve, reject) => {

				global.axios.request({
					method: 'post',
					url: '/contact-requests/' + identifier + '/untrash',
					validateStatus: ( status ) => { return status == 200; },
				})
				.then(response => {
					const updatedList = state.requestsList.map(item => {
						if (item.id === identifier ) {
							let holder = item;
							holder.trash = 0;
							return holder;
						} else {
							return item;
						};
					});
					commit( 'updateRequestList', updatedList );
				})
				.catch(error => reject( error ));

			});

		},

		reset( { commit, state } ) {
			commit( 'resetState' );
		}

	}
}


// WEBPACK FOOTER //
// ./src/custom/controllers/Contact-requests.js